import React from 'react';
import Slider from 'react-slick';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import s from './ConstituencyMapWrapper.scss';
import ConstituencyWidget from '../ConstituencyWidget/ConstituencyWidget';
import ConstituencyCandidateVersus from '../ConstituencyCandidateVersus';
import HeaderTab from '../../../routes/home/components/desktop/HeaderTabV2';
import {
  filterSearchSortData,
  loadYearWiseConstituencyDatahubData,
} from '../../../routes/newslisting/redux';
import LoaderSpinner from '../LoaderSpinner';
import SortSelect from '../SortSelect';
import Listingheader from '../../../routes/home/components/common/ListingheaderV2';
import CandidateCard from '../../../components/ElectionV2/common/CandidateCard/CandidateCard';
import GainRetainTable from '../../../components/ElectionV2/common/SeatChangeTable/GainRetainTable';
import SwitchTabs from '../../../components/ElectionV2/common/SwitchTabs/SwitchTabs';
import DraggableZoomable from '../DraggableZoomable/DraggableZoomable';

class ConstituencyMapWrapper extends React.Component {
  constructor(props) {
    super(props);
    this.selectedConst = Object.values(props.stateConstMapping).flat();
    this.selectedConst = [
      {
        name: 'Constituencies',
        seoname: '',
      },
      ...this.selectedConst,
    ];
    this.tabs = [
      { name: 'SEAT SHIFT', index: 0 },
      { name: 'CONSTITUENCY MAP', index: 1 },
    ];
    this.state = {
      sort: { alpha: 1, key: 'slug' },
      searches: {},
      hoveredData: null,
      selectedOption: [],
      selectedPartyOption: '',
      gainRetain: false,
      selectedConst: this.selectedConst,
      selectedConstituencyOption: this.selectedConst[0],
    };
    this.mapRef = React.createRef();

    try {
      const { electionData } = props?.sectionItem?.items || {};
      const latestData =
        Object.values(electionData) &&
        Array.isArray(Object.values(electionData)) &&
        Object.values(electionData)
          .filter(e => e.datahubUrl)
          .sort((a, b) => b.year - a.year);
      if (latestData && Array.isArray(latestData) && latestData.length) {
        const { live, source, datahubSVG } = latestData[0];
        this.state.live = live;
        this.state.source = source;
        this.state.datahubSVG = datahubSVG;
        this.state.selectedYear = Object.values(electionData).sort(
          (a, b) => b.year - a.year,
        )[0].year;
      }
    } catch (error) {
      //
    }
    this.sortMapping = [
      {
        method: 'alpha',
        name: 'Alphabet',
        seoname: 'alphabet',
        order: 1,
        key: 'slug',
      },
    ];
    this.DEBOUNCE_DELAY = 500;
  }

  handleHover = data => {
    this.setState({ hoveredData: data });
  };

  handleClick = data => {
    if (this.props.isWapView) {
      this.setState({ hoveredData: data });
    } else if (!this.props.isWapView) {
      window.open(data.link, '_blank');
    }
  };

  handleMouseLeave = () => {
    this.setState({ hoveredData: null });
  };

  handleHoverCallback = data => () => this.handleHover(data);
  handleClickCallback = data => () => this.handleClick(data);

  mapFiller = (gainRetain = false) => {
    const { filteredData, fullData } = this.props;
    if (fullData && Array.isArray(fullData) && fullData.length > 0) {
      fullData.forEach(data => {
        if (this.mapRef.current) {
          const pathElement = this.mapRef.current.querySelector(
            `path[id='${data.cns_id}']`,
          );
          if (pathElement) {
            pathElement.setAttribute('data-opacity', '1');
            pathElement.setAttribute('style', `fill: '#fff'`);
          }
          pathElement.removeEventListener(
            'mouseenter',
            this.handleHoverCallback(data),
          );
          pathElement.removeEventListener('mouseleave', this.handleMouseLeave);
          pathElement.removeEventListener(
            'click',
            this.handleClickCallback(data),
          );
          if (!this.props.isWapView) {
            pathElement.addEventListener(
              'mouseenter',
              this.handleHoverCallback(data),
            );
            pathElement.addEventListener('mouseleave', this.handleMouseLeave);
          }
          pathElement.addEventListener('click', this.handleClickCallback(data));
        }
      });
    }
    const intersection = fullData.filter(obj1 =>
      filteredData.some(obj2 => obj1.cns_id === obj2.cns_id),
    );
    if (
      intersection &&
      Array.isArray(intersection) &&
      intersection.length > 0
    ) {
      intersection.forEach(data => {
        if (this.mapRef.current) {
          const pathElement = this.mapRef.current.querySelector(
            `path[id='${data.cns_id}']`,
          );
          if (pathElement) {
            if (gainRetain && data?.inan === data?.lwan) {
              pathElement.setAttribute('data-opacity', '0.4');
            } else {
              pathElement.setAttribute('data-opacity', '1');
            }
            pathElement.setAttribute('style', `fill: ${data.lwcc || '#fff'}`);
          }
        }
      });
    }
  };

  componentDidMount() {
    const { fullData } = this.props;
    if (fullData && Array.isArray(fullData) && fullData.length > 0) {
      fullData.forEach(data => {
        if (this.mapRef.current) {
          const pathElement = this.mapRef.current.querySelector(
            `path[id='${data.cns_id}']`,
          );
          if (pathElement) {
            pathElement.setAttribute('style', `fill: ${data.lwcc}`);
            if (!this.props.isWapView) {
              pathElement.addEventListener('mouseenter', () =>
                this.handleHover(data),
              );
              pathElement.addEventListener('mouseleave', this.handleMouseLeave);
            }
            pathElement.addEventListener('click', () => this.handleClick(data));
          }
        }
      });
    }

    const { electionData } = this.props.sectionItem.items;
    if (electionData) {
      const liveData =
        Object.values(electionData) &&
        Array.isArray(Object.values(electionData)) &&
        Object.values(electionData).filter(data => data.live);
      if (liveData && Array.isArray(liveData) && liveData.length) {
        const data = Object.values(electionData).filter(d => d.live)[0];
        setInterval(() => {
          if (data.link && data.year && data.year === this.state.selectedYear) {
            this.props.loadAjaxElectionData(
              data,
              this.state.searches,
              this.state.sort,
              false,
              this.props.force,
            );
          }
        }, 30 * 1000);
      }
    }
  }

  componentDidUpdate(prevPros) {
    if (
      JSON.stringify(prevPros.filteredData) !==
      JSON.stringify(this.props.filteredData)
    ) {
      this.mapFiller(this.state.gainRetain);
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({
        hoveredData: null,
      });
    }
  }

  debounce = (func, delay) => {
    let timerId;
    return (...args) => {
      if (timerId) {
        clearTimeout(timerId);
      }
      timerId = setTimeout(() => {
        func(...args);
      }, delay);
    };
  };

  debouncedSearch = this.debounce(searches => {
    this.props.filterData(searches, this.state.sort);
  }, this.DEBOUNCE_DELAY);

  onTabsChange = params => {
    const { year, live, source } = params.clickedItem;
    const { electionData } = this.props.sectionItem.items;
    this.setState({ selectedYear: year, live, source });
    this.props.loadAjaxElectionData(
      electionData[year],
      this.state.searches,
      this.state.sort,
      true,
      this.props.force,
    );
  };

  handleSearchChange = e => {
    const term = e.target.value;
    this.setState({ searches: { ...this.state.searches, slug: term } }, () => {
      this.debouncedSearch(this.state.searches);
    });
  };

  tabHandler = tab => {
    const gainRetain = tab?.index === 0;
    this.setState({ gainRetain }, () => {
      this.mapFiller(this.state.gainRetain);
    });
  };

  handlePartyChange = item => {
    this.setState(
      {
        searches: { ...this.state.searches, lwan: item.lwan },
        selectedPartyOption: item,
      },
      () => {
        this.props.filterData(
          this.state.searches,
          this.state.sort,
          false,
          false,
          this.props.partiesAndRetainedSeatsFilter,
        );
      },
    );
  };

  handleConstituncyChange = item => {
    this.setState(
      {
        searches: { ...this.state.searches, cns_name: item.seoname },
        selectedConstituencyOption: item,
      },
      () => {
        this.props.filterData(this.state.searches, this.state.sort);
      },
    );
  };

  findIntersection = arr => {
    if (!arr.length) return [];
    const cleanedArray = arr.filter(
      subArray => Array.isArray(subArray) && subArray.length > 0,
    );
    if (!cleanedArray.length) return [];

    // Take the first array as the base and filter its elements
    return cleanedArray[0].filter(item =>
      cleanedArray.every(subArray => subArray.includes(item)),
    );
  };

  handleOptionChange = (item, index) => {
    this.setState(
      prevState => {
        const updatedOptions = [...prevState.selectedOption];
        updatedOptions[index] = item;
        let updatedCnsIDs = updatedOptions.map(option => option?.cns_id);
        updatedCnsIDs = this.findIntersection(updatedCnsIDs);
        return {
          selectedOption: updatedOptions,
          searches: { ...this.state.searches, cns_id: updatedCnsIDs },
        };
      },
      () => {
        this.props.filterData(this.state.searches, this.state.sort);
      },
    );
  };

  render() {
    const { electionData, stateName = '' } = this.props.sectionItem.items;
    const {
      filtersData,
      partiesAndRetainedSeatsFilter,
      partiesAndRetainedSeats,
      filteredData,
    } = this.props;
    const settings = {
      dots: true,
      slidesToShow: 8,
      slidesToScroll: 8,
      arrows: true,
      infinite: false,
    };
    return (
      <div className={`${s.constituencyMapWrapper}`}>
        {this.props.dataLoading && <LoaderSpinner />}
        {!this.props.isWapView && (
          <>
            <div className={s.topRow}>
              <div className={s.headinWrap}>
                <h2 className={s.tabWrapText}>
                  Interactive Results Hub {!!stateName && `of ${stateName}`}
                </h2>
                <div className={s.tabs}>
                  <HeaderTab
                    subSections={Object.values(electionData)
                      .filter(e => e.datahubUrl)
                      .sort((a, b) => b.year - a.year)
                      .map(item => ({ ...item, link: item.datahubUrl }))}
                    onChangeCallback={this.onTabsChange}
                  />
                </div>
              </div>
              <div className={s.searchBox}>
                <SortSelect
                  searchOperation
                  options={this.state.selectedConst}
                  onSelect={this.handleConstituncyChange}
                  selectedOption={this.state.selectedConstituencyOption}
                />
              </div>
            </div>
            <div className={s.filtersWrap}>
              <div className={s.sortSelectWrap}>
                {partiesAndRetainedSeatsFilter &&
                  Array.isArray(partiesAndRetainedSeatsFilter) &&
                  partiesAndRetainedSeatsFilter.length > 0 && (
                    <SortSelect
                      options={partiesAndRetainedSeatsFilter}
                      onSelect={this.handlePartyChange}
                      selectedOption={
                        this.state.selectedPartyOption ||
                        partiesAndRetainedSeatsFilter[0]
                      }
                    />
                  )}

                {filtersData &&
                  Array.isArray(filtersData) &&
                  filtersData.length > 0 &&
                  filtersData.map((item, index) => (
                    <SortSelect
                      options={item}
                      onSelect={this.handleOptionChange}
                      selectedOption={
                        this.state.selectedOption[index] || item[0]
                      }
                      selectIndex={index}
                    />
                  ))}
              </div>
              <SwitchTabs
                tabs={this.tabs}
                tabHandler={this.tabHandler}
                isToggle
                activeTabIndex={1}
              />
            </div>
            <div className={s.mapContainer}>
              <div className={s.changeTableWrap}>
                {partiesAndRetainedSeats &&
                  Array.isArray(partiesAndRetainedSeats) &&
                  partiesAndRetainedSeats.length > 0 && (
                    <GainRetainTable
                      filteredData={filteredData}
                      parties={partiesAndRetainedSeats}
                      logo={false}
                      isWapView={this.props.isWapView}
                      gainRetain={this.state.gainRetain}
                    />
                  )}
              </div>
              {this.props.datahubMap &&
                this.state.datahubSVG && (
                  <div className={s.svgMap}>
                    <DraggableZoomable>
                      <div
                        ref={this.mapRef}
                        dangerouslySetInnerHTML={{
                          __html: this.props.datahubMap,
                        }}
                      />
                    </DraggableZoomable>
                  </div>
                )}

              <div className={s.constituencyFloater}>
                {this.state.hoveredData && (
                  <ConstituencyWidget
                    title={this.state.hoveredData.cns_name}
                    toBeDecided={
                      this.state.hoveredData.lw_status === 2 ||
                      this.state.hoveredData.lw_status === 1
                    }
                    link={this.state.hoveredData.link}
                    infoText={
                      this.props.loksabha ? this.state.hoveredData.sn : ''
                    }
                  >
                    <ConstituencyCandidateVersus
                      candidates={this.state.hoveredData}
                      toBeDecided={[1, 2, 3, 4, '1', '2', '3', '4'].includes(
                        this.state.hoveredData.lw_status,
                      )}
                      loksabha={this.props.loksabha}
                    />
                  </ConstituencyWidget>
                )}
                <p className={s.noteText}>
                  {this.state.gainRetain && (
                    <>
                      A dark colour indicates a seat gained. <br />
                      A lighter colour indicates a seat retained.
                    </>
                  )}
                  {electionData[this.state.selectedYear] &&
                    electionData[this.state.selectedYear].note &&
                    `Note: ${electionData[this.state.selectedYear].note}`}
                </p>
              </div>
            </div>
          </>
        )}

        {this.props.isWapView && (
          <>
            <div className={s.topRow}>
              <div className={s.headinWrap}>
                <div className={s.tabs}>
                  <HeaderTab
                    subSections={Object.values(electionData)
                      .filter(e => e.datahubUrl)
                      .sort((a, b) => b.year - a.year)
                      .map(item => ({ ...item, link: item.datahubUrl }))}
                    onChangeCallback={this.onTabsChange}
                  />
                </div>
              </div>
            </div>
            <SwitchTabs
              tabs={this.tabs}
              tabHandler={this.tabHandler}
              isToggle
              activeTabIndex={1}
            />
            <div className={s.changeTableWrap}>
              {partiesAndRetainedSeats &&
                Array.isArray(partiesAndRetainedSeats) &&
                partiesAndRetainedSeats.length > 0 && (
                  <GainRetainTable
                    filteredData={filteredData}
                    parties={partiesAndRetainedSeats}
                    logo={false}
                    isWapView={this.props.isWapView}
                    gainRetain={this.state.gainRetain}
                  />
                )}
            </div>
            <div className={s.filtersWrap}>
              <div className={s.sortSelectWrap}>
                {partiesAndRetainedSeatsFilter &&
                  Array.isArray(partiesAndRetainedSeatsFilter) &&
                  partiesAndRetainedSeatsFilter.length > 0 && (
                    <SortSelect
                      options={partiesAndRetainedSeatsFilter}
                      onSelect={this.handlePartyChange}
                      selectedOption={
                        this.state.selectedPartyOption ||
                        partiesAndRetainedSeatsFilter[0]
                      }
                    />
                  )}

                {filtersData &&
                  Array.isArray(filtersData) &&
                  filtersData.length > 0 &&
                  filtersData.map((item, index) => (
                    <SortSelect
                      options={item}
                      onSelect={this.handleOptionChange}
                      selectedOption={
                        this.state.selectedOption[index] || item[0]
                      }
                      selectIndex={index}
                    />
                  ))}
              </div>
            </div>
            <div className={s.mapContainer}>
              {this.props.dataLoading && <LoaderSpinner />}
              {this.props.datahubMap &&
                this.state.datahubSVG && (
                  <div className={s.svgMap}>
                    <DraggableZoomable isWapView>
                      <div
                        ref={this.mapRef}
                        dangerouslySetInnerHTML={{
                          __html: this.props.datahubMap,
                        }}
                      />
                    </DraggableZoomable>
                  </div>
                )}
              <div className={s.constituencyFloater}>
                <p className={s.noteText}>
                  {this.state.gainRetain && (
                    <>
                      A dark colour indicates a seat gained. <br />
                      A lighter colour indicates a seat retained.
                    </>
                  )}
                  {electionData[this.state.selectedYear] &&
                    electionData[this.state.selectedYear].note &&
                    `Note: ${electionData[this.state.selectedYear].note}`}
                </p>
                {this.state.hoveredData && (
                  <ConstituencyWidget
                    title={this.state.hoveredData.cns_name}
                    toBeDecided={
                      this.state.hoveredData.lw_status === 2 ||
                      this.state.hoveredData.lw_status === 1
                    }
                    link={this.state.hoveredData.link}
                    infoText={
                      this.props.loksabha ? this.state.hoveredData.sn : ''
                    }
                  >
                    <ConstituencyCandidateVersus
                      candidates={this.state.hoveredData}
                      toBeDecided={[1, 2, 3, 4, '1', '2', '3', '4'].includes(
                        this.state.hoveredData.lw_status,
                      )}
                      loksabha={this.props.loksabha}
                    />
                  </ConstituencyWidget>
                )}
              </div>
            </div>
          </>
        )}

        {this.props.starCandidatesData &&
          Array.isArray(this.props.starCandidatesData) &&
          this.props.starCandidatesData.length > 0 && (
            <>
              <Listingheader headingname="Star Candidates" />
              <div className={s.candidateWrap}>
                {!this.props.isWapView && (
                  <div className="slick_UI smallArrow smallArrowBlack">
                    <Slider {...settings}>
                      {this.props.starCandidatesData.map((item, idx) => (
                        <CandidateCard
                          candidate={item}
                          index={idx}
                          isWapView={this.props.isWapView}
                        />
                      ))}
                    </Slider>
                  </div>
                )}
                {this.props.isWapView && (
                  <div className={s.scrollWrap}>
                    {this.props.starCandidatesData.map((item, idx) => (
                      <CandidateCard
                        candidate={item}
                        index={idx}
                        isWapView={this.props.isWapView}
                      />
                    ))}
                  </div>
                )}
              </div>
              {this.state.source && (
                <div className={`${s.source} ${s.cl}`}>
                  Source: {this.state.source}
                </div>
              )}
            </>
          )}
      </div>
    );
  }
}

const mapDispatchtoProps = dispatch => ({
  loadAjaxElectionData: (
    year,
    searches,
    sort,
    loader = false,
    force = false,
  ) => {
    dispatch(
      loadYearWiseConstituencyDatahubData(year, searches, sort, loader, force),
    );
  },
  filterData: (
    searches,
    sort,
    loader = false,
    schedule = false,
    parties = null,
  ) => {
    dispatch(filterSearchSortData(searches, sort, loader, schedule, parties));
  },
});

const mapStateToProps = state => ({
  filteredData: state.newslisting && state.newslisting.filteredData,
  fullData: state?.newslisting?.fullData,
  datahubMap: state?.newslisting?.datahubMap,
  starCandidatesData: state?.newslisting?.starCandidatesData,
  dataLoading: state?.newslisting?.dataLoading,
  partiesAndRetainedSeats: state?.newslisting?.partiesAndRetainedSeats,
  stateConstMapping: state?.newslisting?.stateConstMapping,
  partiesAndRetainedSeatsFilter:
    state?.newslisting?.partiesAndRetainedSeatsFilter,
  filtersData: state?.newslisting?.filtersData,
});

ConstituencyMapWrapper.propTypes = {
  filteredData: PropTypes.objectOf({}),
  dataLoading: false,
  isWapView: false,
};
ConstituencyMapWrapper.defaultProps = {
  filteredData: {},
  dataLoading: false,
  isWapView: false,
};

export default connect(mapStateToProps, mapDispatchtoProps)(
  ConstituencyMapWrapper,
);
